import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { SecurityInsightsCheckExceptionsPayload } from '@cast/types';

import { getBestPracticeCheckExceptionsQueryKey } from 'hooks/queries/security-insights/useBestPracticeCheckExceptionsQuery';
import { getBestPracticeChecksQueryKey } from 'hooks/queries/security-insights/useBestPracticeChecksQuery';

export const useSaveBestPracticeCheckExceptionsMutation = (
  ruleId: string,
  successMessage = 'Exception configuration was successfully applied.'
): UseMutationResult<
  unknown,
  unknown,
  SecurityInsightsCheckExceptionsPayload,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => {
      return apiClient.securityInsights.saveCheckExceptions({
        ruleId,
        payload,
      });
    },
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: getBestPracticeCheckExceptionsQueryKey(ruleId),
      });
      queryClient.invalidateQueries({
        queryKey: getBestPracticeChecksQueryKey(),
      });
      notify.success(successMessage);
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
